import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {MyMercatusAccount} from "./my-mercatus-account";

@Injectable({
    providedIn: 'root'
})
export class MyMercatusService {
    baseUrl: string = `${environment.apiUrl}/my-mercatus`;

    constructor(private http: HttpClient) {
    }

    generateAccounts(jobId: string) {
        const query = `${this.baseUrl}/jobs/generate-accounts/${jobId}`;
        return this.http.post(query, "");
    }

    public deleteAccount(id: string) {
        const query = `${this.baseUrl}/accounts/${id}`;
        return this.http.delete(query);
    }

    public invite(contactId: number, additionalInvitationMail: string): Observable<MyMercatusAccount> {
        const query = `${this.baseUrl}/accounts`;
        return this.http.post<MyMercatusAccount>(query, {"contactId": contactId, additionalInvitationMail });
    }

    public inviteAgain(myMercatusId: string, additionalInvitationMail: string) {
        const query = `${this.baseUrl}/jobs/account-activations`;
        return this.http.post(query, {"id": myMercatusId, additionalInvitationMail });
    }

    public getTenantInvitationTemplate(): Observable<string> {
        const query = `${this.baseUrl}/settings/invitation-template`;
        return this.http.get<string>(query);
    }

    public updateTenantInvitationTemplate(template: string) {
        const query = `${this.baseUrl}/settings/invitation-template`;
        return this.http.post(query, { template });
    }
}
